import React, { useState } from 'react';
import { X } from 'lucide-react';
import { Dialog, DialogContent } from '../components/ui/dialog';
import SEO from '../components/SEO';

const Photos = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  const photoGallery = [
    {
      category: "Séjour & Salon",
      images: [
        { url: "https://www.villanomadelesportesenre.com/medias/images/8.jpg", caption: "Séjour Nomade" },
        { url: "https://www.villanomadelesportesenre.com/medias/images/9.jpg", caption: "Salon avec vue" },
        { url: "https://www.villanomadelesportesenre.com/medias/images/11.jpg", caption: "Espace de vie" },
        { url: "https://www.villanomadelesportesenre.com/medias/images/12.jpg", caption: "Salon confortable" },
        { url: "https://www.villanomadelesportesenre.com/medias/images/13.jpg", caption: "Vue intérieure" }
      ]
    },
    {
      category: "Cuisine",
      images: [
        { url: "https://www.villanomadelesportesenre.com/medias/images/10.jpg", caption: "Cuisine Nomade" },
        { url: "https://www.villanomadelesportesenre.com/medias/images/7.jpg", caption: "Espace cuisine" }
      ]
    },
    {
      category: "Chambres",
      images: [
        { url: "https://www.villanomadelesportesenre.com/medias/images/17.jpg", caption: "Chambre double" },
        { url: "https://www.villanomadelesportesenre.com/medias/images/22.jpg", caption: "Chambre principale" },
        { url: "https://www.villanomadelesportesenre.com/medias/images/19.jpg", caption: "Chambre 2 lits simples" },
        { url: "https://www.villanomadelesportesenre.com/medias/images/24.jpg", caption: "Chambre double" },
        { url: "https://www.villanomadelesportesenre.com/medias/images/23.jpg", caption: "Espace nuit" }
      ]
    },
    {
      category: "Salles de Bain",
      images: [
        { url: "https://www.villanomadelesportesenre.com/medias/images/18.jpg", caption: "Salle de douche" },
        { url: "https://www.villanomadelesportesenre.com/medias/images/20.jpg", caption: "Salle de bain" }
      ]
    },
    {
      category: "Spa & Extérieurs",
      images: [
        { url: "https://www.villanomadelesportesenre.com/medias/images/spa2.jpg", caption: "Spa villa Nomade" },
        { url: "https://www.villanomadelesportesenre.com/medias/images/30.jpg", caption: "Extérieur" },
        { url: "https://www.villanomadelesportesenre.com/medias/images/31.jpg", caption: "Gardin" },
        { url: "https://www.villanomadelesportesenre.com/medias/images/32.jpg", caption: "Terrasse" },
        { url: "https://www.villanomadelesportesenre.com/medias/images/dsc01634-1-.jpg", caption: "Villa Nomade" },
        { url: "https://www.villanomadelesportesenre.com/medias/images/img-1715.jpg", caption: "Cour Intérieure" }
      ]
    },
    {
      category: "Environnement",
      images: [
        { url: "https://www.villanomadelesportesenre.com/medias/images/capture-d-ecran-2021-11-01-182021.jpg", caption: "Golf trousse chemise" },
        { url: "https://www.villanomadelesportesenre.com/medias/images/30.jpg", caption: "Plage de la Loge" }
      ]
    }
  ];

  return (
    <div className="min-h-screen bg-stone-50 py-16 px-4">
      <SEO 
        title="Album Photos - Villa Nomade Les Portes en Ré"
        description="Découvrez en images la Villa Nomade : chambres, spa de nage, jardin, terrasses et les magnifiques environs des Portes en Ré sur l'île de Ré."
        keywords="photos villa ile de ré, villa nomade photos, portes en ré images, location vacances photos"
      />
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-serif mb-4 text-stone-800">Album Photos</h1>
          <p className="text-lg text-stone-600">Découvrez la Villa Nomade et ses environs</p>
        </div>

        <div className="space-y-12">
          {photoGallery.map((section, sectionIndex) => (
            <div key={sectionIndex}>
              <h2 className="text-2xl font-serif mb-6 text-amber-700 border-b-2 border-amber-200 pb-2">
                {section.category}
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                {section.images.map((photo, photoIndex) => (
                  <div
                    key={photoIndex}
                    className="group relative overflow-hidden rounded-lg shadow-md cursor-pointer hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
                    onClick={() => setSelectedImage(photo)}
                  >
                    <img
                      src={photo.url}
                      alt={photo.caption}
                      className="w-full h-64 object-cover group-hover:scale-110 transition-transform duration-500"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                      <div className="absolute bottom-0 left-0 right-0 p-4">
                        <p className="text-white font-medium">{photo.caption}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Plan de la Villa */}
        <div className="mt-12">
          <h2 className="text-2xl font-serif mb-6 text-amber-700 border-b-2 border-amber-200 pb-2">
            Plan de la Villa
          </h2>
          <div className="bg-white rounded-lg shadow-lg p-4">
            <img
              src="https://www.villanomadelesportesenre.com/medias/images/plan-villa.jpg"
              alt="Plan de la villa"
              className="w-full h-auto cursor-pointer"
              onClick={() => setSelectedImage({ url: "https://www.villanomadelesportesenre.com/medias/images/plan-villa.jpg", caption: "Plan de la villa" })}
            />
          </div>
        </div>
      </div>

      {/* Image Modal */}
      <Dialog open={!!selectedImage} onOpenChange={() => setSelectedImage(null)}>
        <DialogContent className="max-w-5xl p-0 bg-black border-none">
          {selectedImage && (
            <div className="relative">
              <button
                onClick={() => setSelectedImage(null)}
                className="absolute top-4 right-4 z-10 bg-white/20 hover:bg-white/30 text-white rounded-full p-2 transition-colors"
              >
                <X className="w-6 h-6" />
              </button>
              <img
                src={selectedImage.url}
                alt={selectedImage.caption}
                className="w-full h-auto max-h-[90vh] object-contain"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-6">
                <p className="text-white text-xl font-medium">{selectedImage.caption}</p>
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default Photos;